export default __webpack_public_path__ + "static/media/icon-pathwayreport_protein.7ce316b8.png";